import OrderList from './OrderList';
import OrderEdit from './OrderEdit';
import OrderIcon from '@mui/icons-material/AttachMoney';

const orders = {
    list: OrderList,
    edit: OrderEdit,
    icon: OrderIcon,
};

export default orders;
